import React from 'react';
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogTrigger } from "@/components/ui/dialog";
import { Tutorial } from "@/assets";

interface NumberFieldProps {
    value: number | string;
    onChange: (value: number | string) => void;
    hasErrors?: boolean;
    required?: boolean;
    label: string;
    description?: string;
    videoUrl?: string;
    activeStep?: number;
    totalSteps?: number;
}

export const NumberField: React.FC<NumberFieldProps> = ({
    value,
    onChange,
    label,
    description,
    hasErrors,
    required,
    videoUrl,
    activeStep = 1,
    totalSteps = 25
}) => {
    const isInvalid = hasErrors && required && (!value && value !== 0);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const onlyNums = e.target.value.replace(/[^0-9]/g, '');
        onChange(onlyNums);
    }

    return (
        <>
            <h1 className="text-background font-bold text-sm sm:text-2xl mb-2.5 sm:mb-4">
                {label}
                {required && <span className="text-red-500 ml-1">*</span>}
            </h1>
            {description && (
                <h2 className="text-grey-light text-sm sm:text-base mb-6 sm:mb-8">{description}</h2>
            )}
            
            <p className="text-grey-light text-xs sm:text-sm mb-4 italic">
                Digite apenas números
            </p>
            
            <div className="flex flex-col justify-center text-xs sm:text-sm gap-4 w-full">
                <Input
                    type="text"
                    value={value}
                    onChange={handleChange}
                    className="placeholder:text-background/60 border-0 border-b border-b-background rounded-none focus-visible:ring-0"
                    placeholder="Ex: 02"
                    onKeyPress={(e) => {
                        // Permite apenas números
                        if (!/[0-9]/.test(e.key)) {
                            e.preventDefault();
                        }
                    }}
                />
                
                {isInvalid && (
                    <div className="text-red-500 text-sm mt-2">Este campo é obrigatório</div>
                )}
            </div>
            
            {videoUrl && (
                <Dialog>
                    <DialogTrigger asChild>
                        <Button variant="ghost" className="flex gap-2 items-center bg-background/10 rounded-md w-fit px-4 py-2 mt-4">
                            <Tutorial fill="var(--background)" />
                            <span>Ver vídeo explicativo</span>
                        </Button>
                    </DialogTrigger>
                    <DialogContent className="aspect-video min-w-2/3 bg-black/90 rounded-2xl border border-gray-800 text-grey-light">
                        <div style={{ left: 0, width: '100%', height: 0, position: 'relative', paddingBottom: '56.25%' }}>
                            <iframe
                                src={videoUrl}
                                style={{ top: 0, left: 0, width: '100%', height: '100%', position: 'absolute', border: 0 }}
                                allowFullScreen
                                scrolling="no"
                                allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share;"
                            >
                            </iframe>
                        </div>
                    </DialogContent>
                </Dialog>
            )}
        </>
    );
}; 